import { ApiCall } from "../../utils/index";
import { GET_COLLABORATOR_OR_CUSTOMER } from "../constants";
import axios from "axios";

export const getCollaboratorOrCustomer =
  (type, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      let url = `/collaborator/by/${type}`;

      const result = await ApiCall.get(url, token);
      dispatch({ type: GET_COLLABORATOR_OR_CUSTOMER, payload: result.data });
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const getCollaboratorOrCustomerListForDataTable =
  (type, debouncedHandleSearch, page, row_count, sortField, sortOrder, cb) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      let url = `/collaborator/by/${type}`;

      const searchParam = debouncedHandleSearch
        ? `search=${debouncedHandleSearch}&`
        : "";
      const params = `?${searchParam}page=${page}&page_size=${row_count}&sort_by=${sortField}&sort_order=${sortOrder}`;
      url = url + params;

      const result = await ApiCall.get(url, token);
      dispatch({ type: GET_COLLABORATOR_OR_CUSTOMER, payload: result.data });
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const createCollaboratorOrCustomer =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post(
        "/collaborator",
        request.payload,
        token
      );
      request.onSuccess();
    } catch (error) {
      request.onError(error);
    }
  };

export const updateCollaboratorOrCustomer =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.patch(
        `/collaborator/${request.collaborator_id}`,
        request.payload,
        token
      );
      request.onSuccess();
    } catch (error) {
      request.onError(error);
    }
  };

export const deleteCollaboratorOrCustomer =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await axios.delete(
        `${process.env.REACT_APP_API_URL}/collaborator/${request.id}`,
        request.payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      request.onSuccess();
    } catch (error) {
      request.onError(error);
    }
  };
